import { render, staticRenderFns } from "./ConfigInputTextLarge.vue?vue&type=template&id=4f959880&scoped=true&"
import script from "./ConfigInputTextLarge.vue?vue&type=script&lang=js&"
export * from "./ConfigInputTextLarge.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInputTextLarge.vue?vue&type=style&index=0&id=4f959880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f959880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f959880')) {
      api.createRecord('4f959880', component.options)
    } else {
      api.reload('4f959880', component.options)
    }
    module.hot.accept("./ConfigInputTextLarge.vue?vue&type=template&id=4f959880&scoped=true&", function () {
      api.rerender('4f959880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputTextLarge.vue"
export default component.exports